import PropTypes from "prop-types";

import { FE_USER_ROLES_CONSTANTS } from "@/admin/constants/AdminConsoleUserRolesConstants";
import AdminConsoleFacultyAdderDistrictAdminSection from "../AdminConsoleFacultyAdderDistrictAdminSection";
import AdminConsoleFacultyAdderSchoolAdminSection from "../AdminConsoleFacultyAdderSchoolAdminSection";
import AdminConsoleFacultyAdderTeacherSection from "../AdminConsoleFacultyAdderTeacherSection";
import AdminConsoleFacultyAdderUserSection from "../AdminConsoleFacultyAdderUserSection";

const propTypes = {
  facultyAdderState: PropTypes.shape({
    userSection: PropTypes.shape({
      firstName: PropTypes.shape({
        value: PropTypes.string,
        touched: PropTypes.bool,
        errorMessage: PropTypes.string,
      }),
      lastName: PropTypes.shape({
        value: PropTypes.string,
        touched: PropTypes.bool,
        errorMessage: PropTypes.string,
      }),
      email: PropTypes.shape({
        value: PropTypes.string,
        touched: PropTypes.bool,
        errorMessage: PropTypes.string,
      }),
      role: PropTypes.shape({
        value: PropTypes.string,
        touched: PropTypes.bool,
        errorMessage: PropTypes.string,
      }),
    }).isRequired,
    roleSection: PropTypes.shape({
      lowestGrade: PropTypes.shape({
        value: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.shape({
            key: PropTypes.number,
            description: PropTypes.string,
          }),
        ]),
        touched: PropTypes.bool,
        errorMessage: PropTypes.string,
      }),
      highestGrade: PropTypes.shape({
        value: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.shape({
            key: PropTypes.number,
            description: PropTypes.string,
          }),
        ]),
        touched: PropTypes.bool,
        errorMessage: PropTypes.string,
      }),
      sisId: PropTypes.string,
      school: PropTypes.shape({
        value: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            uniqueId: PropTypes.string,
          }),
        ]),
        touched: PropTypes.bool,
        errorMessage: PropTypes.string,
      }).isRequired,
      isTeacher: PropTypes.bool,
      subjects: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          name: PropTypes.string,
          checked: PropTypes.bool,
        }),
      ).isRequired,
    }).isRequired,
    step: PropTypes.number,
  }),
  dispatchAction: PropTypes.func.isRequired,
};

const AdminConsoleFacultyAdderModalContent = ({
  facultyAdderState,
  dispatchAction,
}) => {
  const { step, userSection, roleSection } = facultyAdderState;
  const role = userSection.role.value;

  if (step === 1) {
    return (
      <AdminConsoleFacultyAdderUserSection
        formValues={userSection}
        dispatchAction={dispatchAction}
      />
    );
  }
  if (role === FE_USER_ROLES_CONSTANTS.TEACHER) {
    return (
      <AdminConsoleFacultyAdderTeacherSection
        formValues={roleSection}
        dispatchAction={dispatchAction}
      />
    );
  }
  if (role === FE_USER_ROLES_CONSTANTS.SCHOOL_ADMIN) {
    return (
      <AdminConsoleFacultyAdderSchoolAdminSection
        formValues={roleSection}
        dispatchAction={dispatchAction}
      />
    );
  }
  if (role === FE_USER_ROLES_CONSTANTS.DISTRICT_ADMIN) {
    return (
      <AdminConsoleFacultyAdderDistrictAdminSection
        formValues={roleSection}
        dispatchAction={dispatchAction}
      />
    );
  }
};

AdminConsoleFacultyAdderModalContent.propTypes = propTypes;

export default AdminConsoleFacultyAdderModalContent;
